import { useMemo } from 'react';
import { useEditorStore } from '../state/editor-store';
import { evaluateGraphMetrics, type GraphMetricsResult } from './evaluate-graph-metrics';

/**
 * SPEC-008 §72/plan §29/T078 — recalculates whenever the graph reference
 * changes (every `commit()` in the store already produces a new graph
 * object, so this stays correct without a bespoke "metrics revision"
 * counter) and whenever the specific metric inputs change. No network
 * request; purely a client-side memoized selector over the pure engine.
 */
export function useFunnelMetrics(): GraphMetricsResult | null {
  const graph = useEditorStore((state) => state.graph);
  return useMemo(() => (graph ? evaluateGraphMetrics(graph) : null), [graph]);
}
